module.exports = __webpack_public_path__ + "img/pro_nine_1.b2a39ee8.jpg";